// JS para o componente Banner Black Friday

export default function setupBannerBlackFriday() {
  const banner = document.querySelector('[data-banner-black-friday]');
  if (!banner) return;

  // Definir a data final de venda (10h 45m 24s a partir de agora para demonstração)
  const saleEndDate = new Date(Date.now() + 10 * 60 * 60 * 1000 + 45 * 60 * 1000 + 24 * 1000);

  // Elementos do countdown
  const daysElement = banner.querySelector('[data-countdown-days]');
  const hoursElement = banner.querySelector('[data-countdown-hours]');
  const minutesElement = banner.querySelector('[data-countdown-minutes]');
  const secondsElement = banner.querySelector('[data-countdown-seconds]');
  const closeBtn = banner.querySelector('[data-close-banner]');
  const daysContainer = banner.querySelector('[data-days-container]');

  // Função para calcular o tempo restante
  function calculateTimeLeft() {
    const now = new Date();
    const difference = saleEndDate.getTime() - now.getTime();

    if (difference <= 0) {
      banner.classList.add('hidden');
      return { days: 0, hours: 0, minutes: 0, seconds: 0, isExpired: true };
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds, isExpired: false };
  }

  // Função para atualizar o display do countdown
  function updateCountdown() {
    const timeLeft = calculateTimeLeft();

    if (timeLeft.isExpired) {
      banner.classList.add('hidden');
      return;
    }

    if (daysContainer && timeLeft.days === 0) {
      daysContainer.style.display = 'none';
    }

    if (daysElement) {
      daysElement.textContent = timeLeft.days;
    }
    if (hoursElement) {
      hoursElement.textContent = String(timeLeft.hours).padStart(2, '0');
    }
    if (minutesElement) {
      minutesElement.textContent = String(timeLeft.minutes).padStart(2, '0');
    }
    if (secondsElement) {
      secondsElement.textContent = String(timeLeft.seconds).padStart(2, '0');
    }
  }

  // Atualizar o countdown imediatamente
  updateCountdown();

  // Atualizar o countdown a cada segundo
  const timer = setInterval(updateCountdown, 1000);

  // Configurar botão de fechar
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      banner.classList.add('hidden');
      clearInterval(timer);
    });
  }

  // Retornar função para limpar o intervalo se necessário
  return () => clearInterval(timer);
}
